import { permissionGuard } from "@/auth/permissionAuthGuard";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import Error from "@/views/Error.vue";
import PartnerPermissions from "@/views/portal/PartnerUnauthorized.vue";
import ReportHome from "@/views/ReportHome.vue";
import ThgClosing from "@/views/thg/ThgClosing.vue";
import ThgContactData from "@/views/thg/ThgContactData.vue";
import ThgErrorPage from "@/views/thg/ThgErrorPage.vue";
import ThgFrequentlyAskedQuestions from "@/views/thg/ThgFrequentlyAskedQuestions.vue";
import ThgHome from "@/views/thg/ThgHome.vue";
import ThgImpactFactor from "@/views/thg/ThgImpactFactor.vue";
import ThgYearSelector from "@/views/thg/ThgYearSelector.vue";
import ThgImpactSelector from "@/views/thg/ThgImpactSelector.vue";
import ThgImpactSelectorWithCustomerAccount from "@/views/thg/ThgImpactSelectorWithCustomerAccount.vue";
import ThgImpactSelectorOnlyCustomerAccount from "@/views/thg/ThgImpactSelectorOnlyCustomerAccount.vue";
import ThgBillingOverview from "@/views/thg/ThgBillingOverview.vue";
import ThgImprint from "@/views/thg/ThgImprint.vue";
import ThgInviteFriends from "@/views/thg/ThgInviteFriends.vue";
import Login from "@/views/thg/ThgLogin.vue";
import ThgOverview from "@/views/thg/ThgOverview.vue";
import ThgPassword from "@/views/thg/ThgPassword.vue";
import ThgPrivacy from "@/views/thg/ThgPrivacy.vue";
import ThgRegistrationImageUpload from "@/views/thg/ThgRegistrationImageUpload.vue";
import ThgSuccess from "@/views/thg/ThgSuccess.vue";
import ThgTerms from "@/views/thg/ThgTerms.vue";
import ThgVehicleOverview from "@/views/thg/ThgVehicleOverview.vue";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { getLoginRoutes } from "./login.router";
import { routes as profileRoutes } from "./profile.router";
import { SettingRoutes } from "./settings.router";

Vue.use(VueRouter);
const routes: Array<RouteConfig> = [];

profileRoutes.forEach(route => {
  routes.push(route);
});

const thgRoutes: Array<RouteConfig> = [
  /**
   * THG Screens
   */
  {
    path: "/" + ReportScreenEnum.thghome,
    component: ThgHome,
    name: ReportScreenEnum.thghome
  },
  {
    path: "/" + ReportScreenEnum.thgimpactfactor,
    component: ThgImpactFactor,
    name: ReportScreenEnum.thgimpactfactor
  },
  {
    path: "/" + ReportScreenEnum.thgcontact,
    component: ThgContactData,
    name: ReportScreenEnum.thgcontact
  },
  {
    path: "/" + ReportScreenEnum.thgclosing,
    component: ThgClosing,
    name: ReportScreenEnum.thgclosing
  },
  {
    path: "/" + ReportScreenEnum.thgimpactselector,
    component: ThgImpactSelector,
    name: ReportScreenEnum.thgimpactselector
  },
  {
    path: "/" + ReportScreenEnum.thgImpactSelectorWithCustomerAccount,
    component: ThgImpactSelectorWithCustomerAccount,
    name: ReportScreenEnum.thgImpactSelectorWithCustomerAccount
  },
  {
    path: "/" + ReportScreenEnum.thgImpactSelectorOnlyCustomerAccount,
    component: ThgImpactSelectorOnlyCustomerAccount,
    name: ReportScreenEnum.thgImpactSelectorOnlyCustomerAccount
  },
  {
    path: "/" + ReportScreenEnum.thgregistration,
    component: ThgRegistrationImageUpload,
    name: ReportScreenEnum.thgregistration
  },
  {
    path: "/" + ReportScreenEnum.thgpassword,
    component: ThgPassword,
    name: ReportScreenEnum.thgpassword
  },

  {
    path: "/" + ReportScreenEnum.thgYearSelection,
    component: ThgYearSelector,
    name: ReportScreenEnum.thgYearSelection
  },
  {
    path: "/thgsuccess",
    component: ThgSuccess,
    name: "ThgSuccess"
  },
  {
    path: "/faq",
    component: ThgFrequentlyAskedQuestions,
    name: "ThgFrequentlyAskedQuestions"
  },
  {
    path: "/impressum",
    component: ThgImprint,
    name: "ThgImprint"
  },
  {
    path: "/agbs",
    component: ThgTerms,
    name: "ThgTerms"
  },
  {
    path: "/datenschutz",
    component: ThgPrivacy,
    name: "ThgPrivacy"
  },
  {
    path: "/vehicle",
    component: ThgVehicleOverview,
    name: "ThgVehicleOverview"
  },
  {
    path: "/overview",
    component: ThgOverview,
    name: "ThgOverview"
  },
  {
    path: "/invite",
    component: ThgInviteFriends,
    name: "ThgInviteFriends"
  },
  {
    path: "/billing",
    component: ThgBillingOverview,
    name: "ThgBillingOverview"
  },
  {
    path: "/error",
    name: "PartnerContactError",
    component: ThgErrorPage
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: PartnerPermissions
  },
  {
    path: "/errors",
    name: "Error",
    component: Error
  },
  {
    path: "*",
    component: ReportHome
  }
];

getLoginRoutes(Login).forEach((route: RouteConfig) => {
  route.path = "/login" + route.path;
  routes.push(route);
});

thgRoutes.forEach(route => {
  routes.push(route);
});

SettingRoutes.forEach((route: RouteConfig) => {
  route.path = "/settings" + route.path;
  routes.push(route);
});

const router = new VueRouter({
  routes,
  // mode: "history",
  base: "/thg/",
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(permissionGuard);

export default router;
